import React from 'react';
import { Home, Lightbulb, Music, GraduationCap, Package } from 'lucide-react';

const MobileNav = ({ activeTab, setActiveTab }) => {
  const menuItems = [
    { id: 'home', icon: Home, label: 'Início', type: 'tab' },
    { id: 'references', icon: Lightbulb, label: 'Referências', type: 'tab' },
    { id: 'sounds', icon: Music, label: 'Músicas', type: 'tab' },
    { id: 'plugin', icon: Package, label: 'Plugin', type: 'tab', badge: 'UPGRADE' },
    { id: 'course', icon: GraduationCap, label: 'Curso', type: 'tab' }
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-[100] font-sans">
      <div className="bg-[#0A0A12]/90 backdrop-blur-xl border-t border-white/10 px-2 py-3 flex items-center justify-between shadow-[0_-10px_30px_rgba(0,0,0,0.5)]">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;

          const baseClasses =
            "flex flex-col items-center justify-center flex-1 gap-1 relative transition-all active:scale-90";

          if (item.type === 'link') {
            return (
              <a
                key={item.id}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className={baseClasses}
              >
                <Icon className="w-6 h-6 text-[#FFD700]" />
                <span className="text-[10px] font-bold uppercase tracking-tighter text-[#FFD700]">
                  {item.label}
                </span>
              </a>
            );
          }

          return (
            <button
              key={item.id}
              onClick={() => setActiveTab(item.id)}
              className={baseClasses}
            >
              {isActive && (
                <span className="absolute -top-3 w-1.5 h-1.5 bg-[#FFD700] rounded-full shadow-[0_0_10px_#FFD700]" />
              )}

              {item.badge && (
                <span className="absolute -top-1 -right-1 text-[7px] font-bold px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-300 uppercase tracking-widest border border-emerald-500/30">
                  {item.badge}
                </span>
              )}

              <Icon
                className={`w-6 h-6 transition-colors duration-300 ${
                  isActive ? 'text-[#FFD700]' : 'text-slate-500'
                }`}
              />

              <span
                className={`text-[10px] font-bold uppercase tracking-tighter transition-colors ${
                  isActive ? 'text-[#FFD700]' : 'text-slate-500'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>

      <div className="bg-[#0A0A12]/90 h-[env(safe-area-inset-bottom,16px)]" />
    </nav>
  );
};

export default MobileNav;
